import { render, staticRenderFns } from "./ZhaoPinText.vue?vue&type=template&id=833a0322&scoped=true"
import script from "./ZhaoPinText.vue?vue&type=script&lang=js"
export * from "./ZhaoPinText.vue?vue&type=script&lang=js"
import style0 from "./ZhaoPinText.vue?vue&type=style&index=0&id=833a0322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833a0322",
  null
  
)

export default component.exports